import Button from 'monday-ui-react-core/dist/Button';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import Tooltip from 'monday-ui-react-core/dist/Tooltip';
import React, { useContext, useMemo, useState } from 'react';
import styled from 'styled-components';
import APP_CONFIG from '../../../config';
import { FileContext } from '../../../context/FileContext';
import { AddColumnDialogue } from '../../AddColumnDialogue';
import CustomButton from '../../CustomButton';
import Dialog from '../../Dialog';

import AssignEmailControllers from './AssignEmailControllers';
import PaymentControllerDialog from './PaymentControllerDialog';
import { useSearchParams } from 'react-router-dom';

const CustomInput = styled.input`
  width: 150px;
  height: 32px;
  border-radius: 4px;
  border: 1px solid #c5c7d0;
  color: #676879;
  font-size: 10px;
  padding-left: 4px;
  ${({ readOnly }) =>
    readOnly ? 'cursor: not-allowed; background-color: #E4E9EE' : ''};

  :focus-visible {
    ${({ readOnly }) => (readOnly ? 'outline: none;' : '')};
  }
`;

const StyledDropdown = styled(Dropdown)`
  width: 300px;
  /* z-index: 1000; */
`;

const Label = styled.span`
  color: var(--light-primary-text-color, #323338);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const PaymentController = ({
  t,
  selectedItem,
  addedFormFields,
  updateFormFields,
  queryData,
}) => {
  const { boardId } = useContext(FileContext);
  const [showAddColumnDialog, setshowAddColumnDialog] = useState({
    show: false,
    type: '',
  });

  const [showSettings, setShowSettings] = useState(false);
  const [buttonLabel, setButtonLabel] = useState(selectedItem?.text || '');
  const [searchParams] = useSearchParams();
  const isV3 = new URLSearchParams(searchParams).get('isV3');

  const statusOptions = useMemo(() => {
    const preSeletedColumns = [];
    addedFormFields
      ?.filter(
        (field) =>
          field.itemId === APP_CONFIG.form_fields.payment.id &&
          field.id !== selectedItem?.id,
      )
      ?.forEach((val) => {
        if (val?.column?.value) {
          preSeletedColumns.push(val.column.value);
        }
      });

    const options = queryData?.data?.items[0]?.column_values
      ?.filter(
        (column) =>
          ['formula', 'numbers'].includes(column.type) &&
          !preSeletedColumns.includes(column.id),
      )
      ?.map((x) => {
        return { value: x.id, label: x.title };
      });

    if (Array.isArray(options)) {
      options.push({
        value: 'add-new-column',
        label: `+ ${t('Add new column')}`,
        onClick: () => {
          setshowAddColumnDialog({ show: true, type: 'numbers' });
        },
      });
    }

    return options;
  }, [queryData]);

  function handleCurrencyChange(currency) {
    selectedItem.currency = currency.value;
    updateFormFields([...addedFormFields]);
  }

  function handleAmountColumnChange(column) {
    if (column?.onClick) {
      column.onClick();
    }
    selectedItem.amountColumn = column.value;
    updateFormFields([...addedFormFields]);
  }

  const handleEditButtonLabelChange = (e) => {
    setButtonLabel(e?.target?.value);
  };

  const changeButtonLabel = (e) => {
    selectedItem.text = e?.target?.value;
    updateFormFields([...addedFormFields]);
  };

  const handleSettingsClose = () => {
    setShowSettings(false);
  };

  return (
    <>
      <Label>Button Label</Label>

      <Tooltip
        content='Set a custom label for the "Make Payment" button'
        position={Tooltip.positions.TOP}
        zIndex={1000}
      >
        <CustomInput
          placeholder="Placehoder text here"
          value={buttonLabel}
          onChange={handleEditButtonLabelChange}
          onBlur={changeButtonLabel}
        />
      </Tooltip>

      {showAddColumnDialog?.show && showAddColumnDialog?.type ? (
        <AddColumnDialogue
          type={showAddColumnDialog.type}
          boardId={boardId}
          handleClose={() => setshowAddColumnDialog({ show: false, type: '' })}
        />
      ) : null}

      <Tooltip
        content="Choose your preferred currency from a dropdown"
        position={Tooltip.positions.TOP}
        zIndex={1000}
      >
        <StyledDropdown
          clearable={false}
          options={APP_CONFIG.currencyList || []}
          size={Dropdown.size.SMALL}
          value={APP_CONFIG?.currencyList?.find(
            (i) => i?.value === selectedItem?.currency,
          )}
          placeholder={`${t('Select Currency')}`}
          className="dropdown-stories-styles_with-chips"
          onChange={handleCurrencyChange}
        />
      </Tooltip>

      <Tooltip
        content="Select or create a column to define the payment amount"
        position={Tooltip.positions.TOP}
        zIndex={1000}
      >
        <StyledDropdown
          clearable={false}
          options={statusOptions || []}
          size={Dropdown.size.SMALL}
          value={statusOptions?.find(
            (i) => i.value === selectedItem.amountColumn,
          )}
          placeholder={`${t('Select Amount Column')}`}
          className="dropdown-stories-styles_with-chips"
          onChange={handleAmountColumnChange}
        />
      </Tooltip>
      <Tooltip
        content="Assign the email controller for the payment button"
        position={Tooltip.positions.TOP}
        zIndex={1000}
      >
        <AssignEmailControllers
          t={t}
          hideTipseen
          selectedItem={selectedItem}
          addedFormFields={addedFormFields}
          updateFormFields={updateFormFields}
        />
      </Tooltip>
      {isV3 ? (
        <div>
          <Tooltip
            content="Open the settings for the payment button"
            position={Tooltip.positions.TOP}
            zIndex={1000}
          >
            <CustomButton
              kind={Button.kinds.PRIMARY}
              onClick={() => setShowSettings(true)}
            >
              {t('Settings')}
            </CustomButton>
          </Tooltip>
        </div>
      ) : null}

      {showSettings && (
        <Dialog
          dialogBody={
            <PaymentControllerDialog
              t={t}
              queryData={queryData}
              setShowAddColumnDialog={setshowAddColumnDialog}
              handleSettingsClose={handleSettingsClose}
            />
          }
          handleClose={handleSettingsClose}
        />
      )}
    </>
  );
};

export default PaymentController;
